export default __webpack_public_path__ + "static/media/logo2.439da091.png";